'use client'
import { FC, useEffect, useState } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { MarketingRoadMapCalender } from '@/components'
import { createClient } from '@/prismicio';
/**
 * Props for `MarketingRoadMap`.
 */
export type MarketingRoadmapProps =
  SliceComponentProps<Content.MarketingRoadmapSlice>;

/**
 * Component for "MarketingRoadMap" Slices.
 */
const MarketingRoadMap: FC<MarketingRoadmapProps> = ({ slice }) => {
  
  const [roadmap, setRoadmap] = useState([]);
  
  useEffect(()=>{

    const client = createClient();

    const getCalender = async () => {
      const roadmapData = await client.getAllByType('marketing_category')as any
      roadmapData ? setRoadmap(roadmapData) : [];
    }

    getCalender();

  },[])
  
  return (
    <>
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="font-fellix px-4 md:px-8 lg:px-12 2xl:px-0 "
    >
      <article className='text-center max-w-[800px] mx-auto block mt-16'>
        <PrismicRichText field={slice.primary.title}/>
      </article>
      <article className='text-center text-[28px] leading-[34px] mt-4 max-w-[800px] mx-auto block'>
        <PrismicRichText field={slice.primary.description}/>
      </article>
    </section>
    <section className="font-fellix pl-4 md:pl-8 lg:pl-12 2xl:px-0" data-component="MarketingRoadMapCalender">
      <MarketingRoadMapCalender data={roadmap} />
    </section>
    </>
  );
};

export default MarketingRoadMap;
